import React, { useState, useEffect, memo, forwardRef, useRef } from 'react';
import { Pagination, Row, Col, Input, Space, Tooltip } from 'antd';
import useSkipFirstEffect from '../../utils/hook/useSkipFirstEffect';
import axiosInstance from '../../utils/axiosInstance';
import fetchWithAuth from '../../utils/customFetch';


const Ption = forwardRef(({ isCustomFetch, onCngPage, onPeding, url, plod, isNotShow = false, itmeName = 'Agreements' }, ref) => {
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [pageSize, setPageSize] = useState(10); // Page size
  const [total, setTotal] = useState(0); // Total number of items (for pagination)
  const [pageInput, setPageInput] = useState(currentPage);
  const minPage = 1;
  const maxPage = Math.ceil(total / pageSize); // Calculate max pages
  const getPayload = () => {
    return {
      page_size: pageSize,
      page_number: currentPage
    }
  };

  // Function to handle page changes
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    setPageInput(page)
  };

  // Fetch data whenever the page or page size changes
  const getData = async () => {
    onPeding(true)
    const payload = { ...plod, ...getPayload() };
    try {
      if(!isCustomFetch){
        const response = await axiosInstance.post( url,payload )
        setTotal(response.data.count); // Set the total number of items
        onCngPage(response.data.results)
      }else{
         const response = await fetchWithAuth({
                method: 'POST',
                endpoint: url,
                data: payload,
            });
            console.log(response, 'response from custom fetch')
        // const response = await fetchWithAuth.post( url,payload )
        setTotal(response.count); // Set the total number of items
        onCngPage(response.results)
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      onPeding(false)
    }
  };

  //   Call the API when component mounts or pagination parameters change
  useEffect(() => {
    getData()
  }, [currentPage, pageSize, url]); // Trigger API call when page or pageSize changes

  useSkipFirstEffect(() => {
    if (currentPage == 1) {
      getData();
    } else {
      setCurrentPage(1)
    }
  }, [plod])

  React.useImperativeHandle(ref, () => ({
    getPayload, // Expose getData method to parent via ref
  }));


  const handlePageInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {  // Only allow numbers
      setPageInput(value);
    }
  };

  const handleEnterPress = () => {
    const pageNumber = Number(pageInput);
    if (pageNumber >= minPage && pageNumber <= maxPage) {
      handlePageChange(pageNumber, pageSize);
    } else {
      setPageInput(currentPage); // Reset if out of range
    }
  };

  return (
    !isNotShow && <div className="pagination-container">
      <Row justify="center">
        <Col>
          <Space size="middle">
            <Pagination
              current={currentPage} // Current page
              pageSize={pageSize} // Items per page
              total={total} // Total number of items
              onChange={handlePageChange} // Handle page change
              showSizeChanger // Show page size changer
              pageSizeOptions={['1', '2', '5', '10', '20', '50']} // Options for page sizes
              onShowSizeChange={handlePageChange} // Handle page size change
              showTotal={(total, range) => (
                <div className='left-heading flex' style={{ width: '100%' }}>
                  <span style={{
                    fontSize: '16px'
                  }}>
                    Total {total} {itmeName}
                  </span>
                  <span className='ml-4' style={{
                    fontSize: '16px',
                    color: '#4CAF50'
                  }}>
                    Showing {range[0]}-{range[1]} {itmeName}
                  </span>
                </div>
              )}
              className='my-2'
            />
            <Tooltip title="Enter page number">
              <Input
                type="text"
                value={pageInput}
                onChange={handlePageInputChange}
                onPressEnter={handleEnterPress} // Navigate on Enter
                placeholder={`Go to (1 - ${maxPage})`}
                className="w-24 border-0 border-b border-gray-400 focus:border-blue-500 focus:ring-0 rounded-none px-2"
              />
            </Tooltip>
          </Space>

        </Col>
      </Row>
    </div>
  );
});

const Pnation = React.memo(Ption);
export default Pnation;
